<script lang="ts">
  import { CheckFilled, Cross, EditFilled, RA, Spinner } from "$components/+blocks/OVIcon";
  import { DashedCircle } from "$components/+blocks/OVIcon";
  import { tooltip } from "app/actions/tooltip";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import Separator from "$components/+blocks/Separator/Separator.svelte";
  import { createEventDispatcher, onMount } from "svelte";
  import { fly } from "svelte/transition";

  export let isPublished: boolean;
  export let isEditing: boolean;
  export let isSaving: boolean;

  const dispatch = createEventDispatcher();
  // ensure animation happens after mount
  let init = false;
  // delay is only for style, so that it pops in after the page content has loaded
  // we only want the delay the first time it flies in
  onMount(() => setTimeout(() => (init = true), 300));
</script>

{#if init}
  <div
    class="flex items-center whitespace-nowrap rounded-full bg-black px-3 py-2 shadow-[0_20px_25px_-5px_rgb(0_0_0/0.1),_0_8px_10px_-6px_rgb(0_0_0/0.50)] transition-[width] dark:bg-gray-100 dark:shadow-[0_20px_25px_-5px_rgb(0_0_0/0.1),_0_8px_10px_-6px_rgb(0_0_0/0.95)]"
    transition:fly={{ y: 150 }}
  >
    {#if isSaving}
      <OVIcon icon={Spinner} class="mr-2 animate-spin text-gray-400" />
    {:else if isEditing}
      <OVIcon icon={EditFilled} class="mr-2 text-gray-400 dark:text-gray-500/90" />
    {:else if isPublished}
      <OVIcon icon={CheckFilled} class="mr-2 text-green-400 dark:text-green-500" />
    {:else}
      <OVIcon icon={DashedCircle} class="mr-2 text-orange-400 dark:text-orange-500" />
    {/if}

    {#if isSaving}
      <span class="text-[13px] font-medium text-white dark:text-gray-800" in:fly={{ y: 4 }}>
        {isPublished ? "Publishing updates" : "Saving updates"}
      </span>
    {:else if isEditing}
      <span class="text-[13px] font-medium text-white dark:text-gray-800" in:fly={{ y: 4 }}>
        Editing draft
      </span>
    {:else}
      <span
        class="text-[13px] font-medium text-white dark:text-gray-800"
        title="Only team members can see this badge"
        use:tooltip
        in:fly={{ y: 4 }}
      >
        Viewing {isPublished ? "" : "un"}published doc
      </span>
    {/if}

    {#if isEditing}
      <Separator class="ml-2 w-[1px]" height="h-[21px]" bgColor="dark:bg-gray-400/70 bg-gray-600" />
      <button
        class="pl-3 text-gray-400 transition-colors hover:text-gray-200 dark:text-gray-500/90 dark:hover:text-gray-800"
        type="button"
        on:click={() => dispatch("close-edit")}
        use:tooltip
        title="Leave edit mode"
        in:fly={{ y: -4 }}
      >
        <OVIcon icon={Cross} size="size-3.5" />
      </button>
    {:else if !isSaving}
      <Separator class="ml-2 w-[1px]" height="h-[21px]" bgColor="dark:bg-gray-400/70 bg-gray-600" />
      <button
        class="inline-flex items-center gap-2 pl-3 text-[13px] font-medium text-gray-400 transition-colors hover:text-gray-200 dark:text-gray-500/90 dark:hover:text-gray-800"
        type="button"
        on:click={() => dispatch("edit")}
        use:tooltip
        title="Edit this document"
        in:fly={{ y: -4 }}
      >
        Edit
        <OVIcon icon={RA} size="size-3" />
      </button>
    {/if}
  </div>
{/if}
